import type {NextPage} from 'next';
import {useEffect} from 'react';
import {RouterHolder} from '@local/logics/global/routerHolder';

const Home: NextPage = () => {
  useEffect(() => {
    RouterHolder.router.push('/login').catch();
  }, []);
  return <div />;
};

export default Home;
